import { createContext, useContext, useEffect, useState } from 'react';
import { loginUser, logoutUser, useIsLoggedInUser } from 'api/login.js';

// This creates a context object with two components – a Provider and a Consumer
const UserAuthContext = createContext();

export const UserAuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    loggedIn: false,
    loading: true,
  });
  const { data, isLoading } = useIsLoggedInUser({ enabled: true });

  const login = async ({ username, password }) => {
    const response = await loginUser({ username, password });

    setAuthState({ loggedIn: response, loading: false });
    return response;
  }

  const logout = async () => {
    await logoutUser();
    console.log('logout called')
    setAuthState({ loggedIn: false, loading: true });
    window.location.href = '/';
  };

  useEffect(() => {
    if(!isLoading) {
      if(data?.status) {
        setAuthState({ loggedIn: true, loading: false });
      } else {
        setAuthState({ loggedIn: false, loading: false });
      }
    }
  }, [data, isLoading]);

  const authContext = {
    loading: authState.loading,
    loggedIn: authState.loggedIn,
    logoutUser: logout,
    loginUser: login
  };

  return (
    <UserAuthContext.Provider value={ authContext }>
      {children}
    </UserAuthContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(UserAuthContext);
}